import i18n from '@/main';

const traduzirSafraSafrinha = (descricao) => {
    if (descricao && descricao.trim() !== '') {
        if (descricao.toLowerCase().includes('safra')) {
            return i18n.t('mensagens.comuns.safra') + ' ' + anoSafra(descricao);
        } else if (descricao.toLowerCase().includes('safrinha')) {
            return i18n.t('mensagens.comuns.safrinha') + ' ' + anoSafra(descricao);
        }
    }

    return '--';
};

function anoSafra(texto) {
  return String(texto).replace(/[^0-9/]/g, '');
}

export default {
    traduzirSafraSafrinha
};
